import { useState, useEffect } from 'react';
import { ProposalsTableDataWithPaginationVariables } from '../../../api/types';
import { PartnerProposalTableFiltersValue, PartnerProposalTableSortingFields } from './types';

export function useTableManager(filters: PartnerProposalTableFiltersValue) {
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 15,
  });

  const [sorting, setSorting] = useState<{ key: PartnerProposalTableSortingFields; value: 'asc' | 'desc' }>({
    key: 'created_date_time',
    value: 'desc',
  });

  useEffect(() => {
    setPagination(prev => ({ ...prev, page: 1 }));
  }, [filters, sorting]);

  return {
    filters,
    sorting: {
      value: sorting,
      onChange: setSorting,
    },
    pagination: {
      value: pagination,
      onChange: setPagination,
    },
    fetchVariables: {
      sort: sorting,
      pagination: { page: pagination.page, perPage: pagination.perPage },
      filters: {
        to: filters.to.toISOString(),
        from: filters.from.toISOString(),
        ...(filters.status !== 'all' ? { status: filters.status } : {}),
        ...(filters.dealType !== 'all' ? { dealType: filters.dealType } : {}),
      },
    } satisfies Omit<ProposalsTableDataWithPaginationVariables['input'], 'accountId'>,
  };
}
